export default "__VITE_ASSET__BjNB3_RF__"